// extracted by mini-css-extract-plugin
export default {"customZoom":"OpenStreetMap_customZoom__OC4kE","marker":"OpenStreetMap_marker__CvVq2","heatmapCanvas":"OpenStreetMap_heatmapCanvas__bdUu6"};